import { Col, Form, Input, Row, Select, Space } from 'antd';
import Button from 'components/Button';
import React from 'react';

export default function DeclareDirect() {
  return (
    <div>
      <Form layout="vertical">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={12}>
            <Form.Item label="Mô hình">
              <Select
                allowClear={true}
                placeholder="Chọn mô hình"
                size="middle"
              ></Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Loại tủ">
              <Select
                allowClear={true}
                placeholder="Chọn Loại tủ"
                size="middle"
              ></Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={12}>
            <Form.Item label="Hình ảnh">
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={18}>
                  <Input placeholder="Định dạng jpg,png" />
                </Col>
                <Col span={6}>
                  <Button
                    color="text-primary-50"
                    bgColor="bg-white"
                    border="border-primary-50"
                  >
                    Browser
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Ngang">
              <Input placeholder="Nhập kích thước (cm)" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Dọc">
              <Input placeholder="Nhập kích thước (cm)" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={12}>
            <Form.Item label="Tên tủ">
              <Input placeholder="Nhập Tên tủ" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="SL món tối thiểu/tủ (Khuyến nghị)">
              <Input placeholder="Nhập số lượng" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className="mt-20 pt-4 border-t-2 border-neutral-90">
        <Form>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mb-1"
          >
            <Col span={12} className="flex justify-end">
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border="border-primary-50"
                >
                  Trở lại
                </Button>
                <Button>Cập nhật</Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}
